<template>
  <v-dialog v-model="dialogLocal" width="500px">
    <v-card>
      <v-card-title>{{lang.add_user}}</v-card-title>
      <v-divider class="ma-0"></v-divider>
      <v-container grid-list-sm class="pa-4 add-sub-user-dialog">
        <v-row>
          <v-col>
            <v-form :v-model="true" ref="form" lazy-validation>
              <v-text-field
                prepend-icon="fa-light fa-envelope"
                v-model="addingEmail"
                :rules="emailRules"
                label="E-mail"
                required
              ></v-text-field>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="ma-0"></v-divider>
      <v-card-actions>
        <v-btn text color="secondary" @click="dialogLocal = false">{{lang.cancel}}</v-btn>
        <v-btn text color="primary" @click="addSubUser">{{lang.add_subuser}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
const manage = require("./manage.js").manage;

export default {
  data() {
    return {
      addingEmail: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  components: {},
  props: {
    dialog: Boolean,
    email: {
      default: false
    }
  },
  watch: {
    dialog: function(val) {
      if (!val) return;
      this.addingEmail = "";
    }
  },
  computed: {
    ...mapState(["lang"]),
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        if (!val) this.$emit("close");
      }
    }
  },
  mounted() {},
  methods: {
    addSubUser() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.dialogLocal = false;
      manage.addSubUser(this.email, this.addingEmail);
    }
  }
};
</script>

<style >
.add-sub-user-dialog .v-input__prepend-outer {
  margin-right: 20px;
}
</style>